import "serviceworker_loader"
import "update_virtual_height_css"
import "i18n_loader"
import "i18n_translations"
import "@hotwired/turbo"
import stimulus_loader from "./stimulus_loader"
import $ from "cash-dom"
// eslint-disable-next-line no-unused-vars
import _ from "lodash"

// NOTE: obfuscased name to avoid browser blocks
import(/* webpackChunkName: "kcarting" */ "tracking").catch(e =>
  // eslint-disable-next-line no-console
  console.error(e)
)

// we don't need to load it when turbo goes to another page only on page load
$(stimulus_loader)
